import { appFetch } from "../../utils/appFetch";
import { AppFetchResponse } from "./automations";

type ApiRes<T> = { ok: true; data: T } | { ok: false; error: string; data: null };

function unwrap<T>(res: AppFetchResponse): ApiRes<T> {
    const ok = res.status >= 200 && res.status < 300;
    const payload = res?.data;
    const data = payload && typeof payload === "object" && "data" in payload ? (payload as any).data : payload;
    const error = payload && typeof payload === "object" && "error" in payload ? String((payload as any).error || "") : "";
    if (!ok) return { ok: false, error: error || "Request failed", data: null };
    return { ok: true, data: data as T };
}

export const TestTrackActivity = async (
    domain: string,
    body: {
        automation_id?: number | null;
        only_condition_checks?: boolean;
        client_id: number;
        event_name: string;
        entity_type?: string | null;
        entity_id?: number | null;
        event_ts?: string;
        meta?: any;
    }
) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: "v2/test/track-activity",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain,
        params: body,
    });
    return unwrap<any>(res);
};

export const TestWorkerTick = async (domain: string) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: "v2/test/worker-tick",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain,
    });
    return unwrap<{ processed: number }>(res);
};

export const TestRecentActivities = async (domain: string, limit = 10) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/test/activities?limit=${encodeURIComponent(String(limit))}`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        domain,
    });
    return unwrap<{
        activities: Array<{
            id: number;
            client_id: number | null;
            event_name: string;
            event_ts: string;
            entity_type: string | null;
            entity_id: number | null;
            meta: any;
        }>;
    }>(res);
};

export const TestResolveClientId = async (
    domain: string,
    body: { email?: string; phone?: string; first_name?: string; last_name?: string }
) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: "v2/test/resolve-client-id",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain,
        params: body,
    });
    return unwrap<{ found: boolean; client_id: number | null; client?: any }>(res);
};

export const TestSearchClients = async (
    domain: string,
    body: { q: string; limit?: number }
) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: "v2/test/search-clients",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain,
        params: body,
    });
    return unwrap<{
        clients: Array<{ id: number; first_name: string | null; last_name: string | null; mail: string | null; phone: string | null }>;
    }>(res);
};
